import { useQuizNavigation, type QuizFormData, type Quiz } from "@core/features/quiz";

type Args = {
  quiz: Quiz | undefined;
  resetIndexKey?: unknown;
  onCompleteQuiz: (formData: QuizFormData) => void;
};

/**
 * Hook for managing anonymous quiz navigation without API persistence.
 * Thin wrapper around useQuizNavigation with anonymous mode enabled.
 */
export function useAnonymousQuizNavigation({
  quiz,
  resetIndexKey,
  onCompleteQuiz,
}: Args) {
  return useQuizNavigation({
    // Cast Quiz to QuizResponse shape - they share the same questionSets structure
    quiz: quiz as Parameters<typeof useQuizNavigation>[0]["quiz"],
    resetIndexKey,
    anonymous: true,
    onCompleteQuiz,
  });
}
